import { forwardRef } from "react";

import Icon from "@/components/Icon";
import LunaThinkingSVG from "./LunaThinkingIcon.svg.jsx";
import type { IconProps } from "@/components/Icon/Icon";

const LunaThinkingIcon = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent">
>((props, ref) => {
  return <Icon ref={ref} SvgComponent={LunaThinkingSVG} {...props} />;
});

export default LunaThinkingIcon;
